
import {useContext, useEffect, useRef, useState} from "react";

import RectangleLeftThirdFilled from "../icons/RectangleLeftThirdFilled";
import RectangleCenterThirdFilled from "../icons/RectangleCenterThirdFilled";
import RectangleRightThirdFilled from "../icons/RectangleRightThirdFilled";
import {App, Button, Input, Modal, Radio, Select, Space} from "antd";
import Clone from "../utils/clone";
import {isAlphanumeric} from "../utils/regex";
import {appContext} from "../state";
import {
    ArrowRightOutlined,
    AudioOutlined,
    CheckOutlined,
    CloseOutlined,
    HeartOutlined,
    SettingFilled
} from "@ant-design/icons";
import Live from "../icons/Live";

function MainMenuBar(props) {

    const [menuIconStates, setMenuIconState] = useState({left:true,center:true,right:true});
    const [subdomains, setSubdomains] = useState([]);
    const [subdomain, setSubdomain] = useState(props.mockAPI);
    const [isSubDomainAvailable, setSubDomainAvailable] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubdomainModalOpen, setIsSubdomainModalOpen] = useState(false);
    const [targetAPIValidationStatus, setTargetAPIValidationStatus] = useState('');
    const [mockAPIValidationStatus, setMockAPIValidationStatus] = useState('');

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const appStateRef = useRef(appState); // inside the event listeners like for sockets/click listeners it will keep the appState defined at the moment the listener was created. This can be outdated
    const { message, modal, notification } = App.useApp();

    useEffect(() => {
        appStateRef.current = appState
    },[appState]);

    useEffect(() => {

    }, []);

    function onClickMenuIcon (e) {
        let target = e.target.closest('.custom-icon')
        if (!target) return
        let key = target.getAttribute('data-key')
        //console.log('key',key,'menuIconStates',menuIconStates)
        if (menuIconStates[key] !== undefined) {
            let newState = Clone(menuIconStates)
            newState[key] = !newState[key]
            setMenuIconState(newState)

            let newAppState = Clone(appState)
            newAppState.menuBarButtons[key] = newState[key]
            setAppState(newAppState)
        }
    }

    async function checkSubdomainAvailability () {
        let isAvailable = await isSubdomainAvailable(subdomain)
        setSubDomainAvailable(isAvailable)
        if (isAvailable) {

        }
    }

    async function isSubdomainAvailable (val) {
        const url = process.env.REACT_APP_SERVER_API_HOST+"/user/subdomain?subdomain="+encodeURIComponent(val);
        try {
            let headers = new Headers();
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'GET',
                headers: headers,
            };
            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            const json = await response.json();
            console.log('RESPONSE:',json)
            return json.available
        } catch (error) {
            console.error(error.message);
            return false
        }
    }

    async function createSubdomain (subdomain) {
        const url = process.env.REACT_APP_SERVER_API_HOST+"/user/subdomain?subdomain="+encodeURIComponent(subdomain);
        try {
            let headers = new Headers();
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
            };
            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            const json = await response.json();
            console.log('RESPONSE:',json)
            return [json.available,json.exists]
        } catch (error) {
            console.error(error.message);
            return false
        }
    }

    async function onChangeMockAPI (e) {
        let val = e.target.value
        let isValid = val && isAlphanumeric(val)
        console.log('ON_CHANGE_MOCK_API',val,"IS_VALID",isValid)
        if (isValid) {
            val = val.toLowerCase()
            setMockAPIValidationStatus('')
            let isAvailable = await isSubdomainAvailable(val)
            if (isAvailable) {
                let newAppState = Clone(appState)
                newAppState.mockAPI = val
                // setAppState(newAppState)
            }
            setSubDomainAvailable(isAvailable)
        } else {
            setMockAPIValidationStatus('error')
        }
    }

    function isValidOrigin (val) {
        const org = /^https?:\/\/(?=.{1,254}(?::|$))(?:(?!\d|-)(?![a-z0-9\-]{1,62}-(?:\.|:|$))[a-z0-9\-]{1,63}\b(?!\.$)\.?)+(:\d+)?$/i;
        return val.match(org) !== null
    }

    async function onChangeTargetAPI (e) {
        let targetAPI = e.target.value
        if (isValidOrigin(targetAPI)) {
            setTargetAPIValidationStatus('')
            const url = process.env.REACT_APP_SERVER_API_HOST+'/user/target-api';
            try {
                console.log('ON_CHANGE_TARGET_API',targetAPI)
                let headers = new Headers();
                headers.append('content-type', 'application/json')
                headers.append("token", localStorage.getItem('token'));
                let requestOptions = {
                    method: 'PUT',
                    headers: headers,
                    body:JSON.stringify({targetAPI:targetAPI})
                }
                const response = await fetch(url, requestOptions);
                if (!response.ok) {
                    console.error(new Error(`Response status: ${response.status}`))
                }
                const json = await response.json();
                console.log('RESPONSE:', json)
            }
            catch (e) {
                console.log(e)
            }
        } else {
            setTargetAPIValidationStatus('error')
        }
    }

    const suffix = () => {
        return <span>
                {isSubDomainAvailable ? <CheckOutlined style={{fontSize: 16, color: '#1677ff'}}/> : null}
                {isSubDomainAvailable === false ?<CloseOutlined style={{fontSize: 16, color: '#ff1616'}}/> : null}
        </span>
    }


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    async function onModalSubdomainConfirm () {
        console.log('onModalSubdomainConfirm')
        let [isAvailable,exists] = await createSubdomain(subdomain)
        if (isAvailable) {
            if (!exists) {
                message.open({type: 'success', content: 'Subdomain created!'});
            }
            setIsSubdomainModalOpen(false);
            let newAppState = Clone(appState)
            newAppState.mockAPI = subdomain
            setAppState(newAppState)
        }
    }

    const onModalSubdomainCancel = () => {
        console.log('onModalSubdomainCancel')
        setIsSubdomainModalOpen(false);
    };

    const toggleLiveMode = async () => {
        let newAppState = Clone(appState)
        newAppState.isLiveModeActive = !newAppState.isLiveModeActive
        setAppState(newAppState)
        try {
            const url = process.env.REACT_APP_SERVER_API_HOST+'/user/toggle-live-mode';
            let headers = new Headers();
            headers.append('content-type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
                body:JSON.stringify({isLiveModeActive:newAppState.isLiveModeActive })
            }
            const response = await fetch(url, requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            const json = await response.json();
        } catch (e) {
            console.log(e)
        }

    }

    async function getSubdomains () {
        try {
            const url = process.env.REACT_APP_SERVER_API_HOST+'/user/subdomains';
            let headers = new Headers();
            headers.append('content-type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'GET',
                headers: headers
            }
            const response = await fetch(url, requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            const subdomains = await response.json();
            //console.log('SUBDOMAINS',subdomains)
            return subdomains
        } catch (e) {
            console.log(e)
            return []
        }
    }

   async function onOpenSubdomainSelector () {
        setIsSubdomainModalOpen(true)
        let subdomains = await getSubdomains()
        setSubdomains(subdomains)
    }

    function onChangeSubdomain (e) {
        setSubdomain(e.target.value)
    }

    function onSelectExistingSubdomain (e) {
        console.log(e.target.value)
        setSubdomain(e.target.value)
    }

    return (
        <div className="menu-bar">
            <div data-is-connected={appState.isConnectedToWs} className="status-indicator"></div>
            <div className="wrapper">
                <div className="left">
                    <div onClick={onOpenSubdomainSelector} className="inputs">
                        <Input status={mockAPIValidationStatus} suffix={suffix()} addonBefore={"https://"}
                               maxLength={30}
                               readOnly={true}
                               defaultValue={props.mockAPI}
                               addonAfter={process.env.REACT_APP_SERVER_MOCK_HOST}/>
                        <ArrowRightOutlined className="arrow"></ArrowRightOutlined>
                        <Input status={targetAPIValidationStatus} onChange={onChangeTargetAPI}
                               defaultValue={props.targetAPI}/>

                        {/*<Input onChange={onChangeTargetAPI} suffix={<SettingFilled onClick={showModal}/>} defaultValue={props.targetAPI}/>*/}
                    </div>

                    {appState.requestsLimit ?<div title={"You have used "+appState.requestsCount+" requests from your quota of "+appState.requestsLimit} className="limits">
                        <div className="requests-received">{appState.requestsCount}</div>
                        <div className="separator">/</div>
                        <div className="requests-limit">{appState.requestsLimit}</div>
                    </div> : false}

                    <div title="Toggle live mode" onClick={toggleLiveMode} data-active={appState.isLiveModeActive ? '1' : ''} className="live-mode">
                        <Live></Live>
                    </div>

                </div>

                <div onClick={onClickMenuIcon} className="icons">
                    <RectangleLeftThirdFilled
                        className={menuIconStates.left ? 'active' : null}></RectangleLeftThirdFilled>
                    {/*<RectangleCenterThirdFilled className={menuIconStates.center ? 'active' : null}></RectangleCenterThirdFilled>*/}
                    <RectangleRightThirdFilled
                        className={menuIconStates.right ? 'active' : null}></RectangleRightThirdFilled>
                </div>
            </div>

            <Modal title="Basic Modal" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
            </Modal>

            <Modal title="Choose Subdomain" open={isSubdomainModalOpen} onOk={onModalSubdomainConfirm} onCancel={onModalSubdomainCancel}>
                <Input status={mockAPIValidationStatus} suffix={suffix()} addonBefore={"https://"}
                       maxLength={30}
                       onChange={onChangeSubdomain}
                       onBlur={checkSubdomainAvailability}
                       value={subdomain}
                       addonAfter={process.env.REACT_APP_SERVER_MOCK_HOST}/>

                <h3>Your Subdomains:</h3>
                <Radio.Group onChange={onSelectExistingSubdomain}>
                    <Space direction="vertical">
                    {subdomains.map( (subdomain) => {
                        return <Radio value={subdomain.name} key={subdomain.id || subdomain.name}>{subdomain.name}</Radio>
                    })}
                    </Space>
                </Radio.Group>
            </Modal>

        </div>
    );
}

export default MainMenuBar;
